export enum TableClassNames {
  HIGHLIGHTED_ROW = 'highlighted-row',
}

export const EDITABLE_TABLE_SINGLE_ACTION_CELL_WIDTH = 34 + 20 // 1 buttons + 20 padding on the sides

export const ATTATCH_SEARCH_ROWS_PER_PAGE = 5
